import { DomSnapshot } from "../declarations/interface";
import BaseService from "./baseService";

class RecordingService extends BaseService {
  constructor() {
    super("/recordings-list");
  }

  async getRecordingById(id: string) {
    return this.get(`/${id}`);
  }

  async updateRecordingName(id: string, name: string) {
    return this.patch(`/${id}`, { recording_name: name });
  }

  async deleteRecordingById(id: string) {
    return this.remove(`/${id}`);
  }

  async getDomListByRecordingId(recordingId: string, params: any) {
    return this.get(`/dom-list/${recordingId}`, params);
  }

  async createNewRecording(
    recording_name: string,
    project_id: number,
    recordingPayload: DomSnapshot[]
  ) {
    return this.post(`/create-recording`, {
      recording_name,
      project_id,
      recordingPayload,
    });
  }
}

export default new RecordingService();
